// eslint-disable-next-line import/prefer-default-export
export const PAGESCONTENT_CHANGE = 'PAGESCONTENT_CHANGE';
export const FILTERS_CHANGE = 'FILTERS_CHANGE';
export const RESET_FILTERS = 'RESET_FILTERS';
export const DROP_FILTER = 'DROP_FILTER';
export const DROP_MULTIPLE_FILTER= 'DROP_FILTER';
